import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Route guard that ensures the user is authenticated (real Supabase session
 * OR dev session via the /login/select-user picker).
 *
 * - Loading  -> centered spinner
 * - Not auth -> redirect to /login
 * - Auth     -> render nested routes via <Outlet />
 */
export function ProtectedRoute() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-accent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
